import clsx from 'clsx'
import React, { FC, useState } from 'react'

import { ImageV2 } from '@Components/Image'
import { Link } from '@Components/Link'
import { LinkedProduct } from '@Globals/CMS/ProductHelpers'

import styles from './LinkedProductItem.module.scss'

interface Props extends LinkedProduct {
  className?: string
  resetVariantId?: () => void
  selected: boolean
  setSelected?: (string) => void
  type: string
}

export const LinkedProductItem: FC<Props> = ({
  className,
  image,
  productID,
  resetVariantId,
  selected,
  setSelected,
  title,
  type,
  url,
}) => {
  const [initialSelected] = useState(selected)
  return (
    <Link
      key={productID}
      analytics={{
        dest_page_type: 'product',
        dest_page_type_id: productID,
        source_id: `linked_products_${type}`,
      }}
      className={clsx(styles.item, initialSelected && styles.initialSelected, selected && styles.selected, className)}
      href={url}
      onMouseOut={resetVariantId}
      onMouseOver={() => setSelected?.(productID)}
    >
      {image && (
        <ImageV2
          alt={title}
          className={styles.image}
          height={90}
          objectFit="contain"
          src={image}
          width={70}
        />
      )}
    </Link>
  )
}
